__webpack_require__.hmrF = () => ("GenAIAssistant." + __webpack_require__.h() + ".hot-update.json");